 document.addEventListener("DOMContentLoaded", function () {
        const mainProductId = 47347750306009;
        const bundleProductId = 47361208156377;

        const addToCartBtns = document.querySelectorAll(".btn.add-to-cart");

        addToCartBtns.forEach((btn) => {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            showDiscountOffer();
        });
        });

        let timerInterval;
        function startTimer() {
            clearInterval(timerInterval);
            let minutes = 7;
            let seconds = 18;

            const timerBar = document.querySelector(".timer-bar span");

            timerInterval = setInterval(function () {
                seconds--;
                if (seconds < 0) {
                    seconds = 59;
                    minutes--;
                }

                if (minutes < 0) {
                    clearInterval(timerInterval);
                    timerBar.textContent = "Special Offer Has Ended";
                    return;
                }

                const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
                const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
                timerBar.textContent = `${formattedMinutes}:${formattedSeconds}`;
            }, 1000);
        }


        function showDiscountOffer() {
            // Prevent duplicate modals
             const existingPopup = document.getElementById("upsell-popup");
            if (existingPopup) existingPopup.remove();

            const offerModal = document.createElement("div");
            offerModal.innerHTML = `
                        <div id="upsell-popup" class="popup-overlay">
    <div class="popup-content">
        <div class="popup-header">
            <h2>Here's a Special One Time Offer!</h2>
            <p>Double your NESIS for a <span>50% discount</span></p>
        </div>
        <div class="timer-bar">
            Special Offer Ends In: <span>07:18</span>
        </div>
        <div class="popup-body">
            <div class="upsell-image-container">
                <img src="https://nesislabs.com/cdn/shop/files/Nesis_Inception_15d_Trial_25__offer_Square_76c42147-cccf-4e31-b3bf-3c3bc54f5cc1.webp" alt="Premium Headphone Case">
            </div>
            <div class="upsell-info">
                <div>
                    <div class="product-title">Nesis Inception<sup>®</sup></div>
                    <div class="up-price-container">
                        <span class="up-original-price">$59.00</span>
                        <span class="up-new-price">$29.00</span>
                        <span class="up-savings">50% Savings</span>
                    </div>
                </div>
                <div class="popup-buttons">
                    <button id="add-upsell-btn">Add to order</button>
                    <button id="no-thanks-btn">Decline this offer</button>
                </div>
            </div>

        </div>
    </div>
</div>
            `;
            document.body.appendChild(offerModal);

            const popupOverlay = document.getElementById('upsell-popup');
            const addUpsellBtn = document.getElementById('add-upsell-btn');
            const noThanksBtn = document.getElementById('no-thanks-btn');
            
            openPopup();

            function openPopup() {
                setTimeout(() => {
                    popupOverlay.classList.add('active');
                    document.body.style.overflow = 'hidden';
                    startTimer();
                }, 10);
            }

           
            function closePopup() {
                popupOverlay.classList.remove('active');
                document.body.style.overflow = 'auto';
                clearInterval(timerInterval);
            }

            noThanksBtn.addEventListener("click", function () {
                closePopup();
                addProduct(mainProductId);
            });

            addUpsellBtn.addEventListener("click", function () {
                closePopup();
                addProduct(bundleProductId);
            });
        }

        function addProduct(productId) {
            const item = {
                id: productId,
                quantity: 1,
            };

            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ items: [item] }),
            })
                .then((res) => {
                    if (!res.ok) throw new Error("Add to cart failed");
                    return res.json();
                })
                .then((data) => {
                    console.log("Added to cart:", data);
                    document.dispatchEvent(new CustomEvent('on:cart:change'));
                    window.location.href = "/checkout"; // go straight to checkout
                })
                .catch((err) => {
                    console.error("Error adding product:", err);
                    alert("Something went wrong. Please try again.");
                });
        }
        
    });